import React from "react";
import GotoDetailsHeader from "./GotoDetailsHeader";

const PhoneNumberHeader = ({
  phoneNumber,
  name,
  status,
  assignedTo,
  assignedToRole,
  label = "Currently assigned to:",
}) => {
  // If assignedTo is provided, use the complex rendering
  if (assignedTo !== undefined) {
    return (
      <GotoDetailsHeader
        title={phoneNumber}
        status={status}
        assignedTo={assignedTo}
        assignedToRole={assignedToRole}
        assignedToLabel={label}
      />
    );
  }

  // Otherwise use simple subtitle
  return (
    <GotoDetailsHeader title={phoneNumber} subtitleLabel="Name" subtitle={name} status={status} />
  );
};

export default PhoneNumberHeader;
